import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";
import AdminLogin from "./pages/AdminLogin";
import Dashboard from "./pages/Dashboard/Dashboard";
import WalletTransactions from "./pages/WalletTransactions";
import CastePreferences from "./pages/CastePreferences";
import Sliderimages from "./pages/EditWebsite/Sliderimages";
import SearchMartialID from "./components/SearchById";
import ThankYou from "./pages/Thankyou";
import Quicksearch2 from "./pages/MyWebSite/QuickSearch2";
import EditYourServices from "./pages/EditWebsite/EditYourServices";
import EditYourLocations from "./pages/EditWebsite/EditYourLocations";
import TermsAndConditions from "./pages/EditWebsite/TermsAndConditions";
import TestimonialsManagement from "./pages/EditWebsite/TestimonialsManagement";
import CustomizedLinksManagement from "./pages/EditWebsite/CustomizedLinksManagement";
import PackagesManagement from "./pages/EditWebsite/PackagesManagement";
import BureauPrivacy from "./pages/Bureauprivacy";
import ProfileHistory from "./pages/profileHistory";
import SearchPage from "./pages/SearchPage";
import AdvancedSearchResults from "./pages/AdvancedSearchResults";
import NavbarLogo from "./pages/EditWebsite/NavbarLogo";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import HowToUse from "./pages/HowToUse";
import CommunityGuidelines from "./pages/CommunityGuidelines";
import { Provider } from "react-redux";
import { store } from "./store";
import ProtectedRoute from "./components/ProtectedRoute";
import GenderProfiles from "./pages/GenderProfiles";
import SuitableProfiles from "./pages/SuitableProfiles";
import ProfileDetailPage from "./pages/ProfileDetails/ProfileDetailPage";
import ShareBureau from "./pages/ShareBureau";
import EditMyProfile from "./pages/EditWebsite/EditMyProfile";
import UserRegister from "./pages/UserCreation/UserRegister";
import ChangePassword from "./pages/ChangePassword";
import EditWebsite from "./pages/EditWebsite";
import { getSessionItem } from "./helpers/function.helper";
import { postRequest } from "./helpers/api.helper";
import {
  getFcmToken,
  initializeNotificationListeners,
} from "./firebase/push-notification.helper";
import SuccessStories from "./pages/EditWebsite/SuccessStories";
import Step1Edit from "./pages/UserProfileEdit/Step1Edit";
import Step2Edit from "./pages/UserProfileEdit/Step2Edit";
import Step3Edit from "./pages/UserProfileEdit/Step3Edit";
import Step4Edit from "./pages/UserProfileEdit/Step4Edit";
import Step5Edit from "./pages/UserProfileEdit/Step5Edit";
import Step6Edit from "./pages/UserProfileEdit/Step6Edit";
import Step7Edit from "./pages/UserProfileEdit/Step7Edit";
import Step8Edit from "./pages/UserProfileEdit/Step8Edit";
import Step9Edit from "./pages/UserProfileEdit/Step9Edit";
import EditSocialMediaLinks from "./pages/EditWebsite/EditSocialMediaLinks";
import MyWebSite from "./pages/MyWebSite/MyWebSite";
import WebsiteProfiles from "./pages/MyWebSite/WebsiteProfiles";
import WebsiteProfileDetail from "./pages/MyWebSite/WebsiteProfileDetail";
import MemberShipDetail from "./pages/MembershipDetail";
import MembershipPlans from "./pages/MembershipPlans";
import MembershipDetails from "./pages/MembershipDetails";
import { StatusBar, Style } from "@capacitor/status-bar";
import MyNotifications from "./components/Mynotifications";
import { Capacitor } from "@capacitor/core";
import { App as CapacitorApp } from "@capacitor/app";
import type { PluginListenerHandle } from "@capacitor/core";
import EditNewDetails from "./pages/EditWebsite/EditNewDetails";
import EditPromotionBanners from "./pages/EditWebsite/EditPromotionBanners";
import Step10Edit from "./pages/UserProfileEdit/Step10Edit";
import Step11Edit from "./pages/UserProfileEdit/Step11Edit";
import EditUserProfile from "./pages/UserProfileEdit/EditUserProfile";
import AddProfileViaText from "./pages/UserCreation/AddProfileViaText";
import SearchByMobilePage from "./pages/SearchByMobilePage";
import AddProfileViaBasic from "./pages/UserCreation/AddProfileViaBasic";
import CallbackProfiles from "./pages/CallbackProfiles";
import NotRespondingProfiles from "./pages/NotRespondingProfiles";
import { Keyboard, KeyboardResize } from "@capacitor/keyboard";
import ProfileOptions from "./pages/ManageProfile";
import QuickSearchResults from "./pages/QuickSearchResults";
import SuccessStoriesPage from "./pages/MyWebSite/Components/SuccessStoriesPage";
import { toast } from "react-toastify";

const NOTIFICATION_DEEP_LINK_PREFIX = "com.matrimonystudio.heeltech://push";
const NOTIFICATION_ENTRY_STATE = { openedFromNotification: true };

const resolveNotificationTargetPath = (url?: string | null) => {
  if (!url) {
    return null;
  }

  try {
    const parsed = new URL(url);

    if (parsed.protocol === "com.matrimonystudio.heeltech:") {
      const target = parsed.searchParams.get("target");
      if (target) {
        return resolveNotificationTargetPath(target);
      }
      return null;
    }

    const isAppDomain =
      parsed.hostname === "matrimonystudio.in" ||
      parsed.hostname === "www.matrimonystudio.in" ||
      parsed.hostname === "localhost";

    if (isAppDomain) {
      return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    }
  } catch {
    // Relative app route.
  }

  if (url.startsWith("/")) {
    return url;
  }

  if (url.startsWith(NOTIFICATION_DEEP_LINK_PREFIX)) {
    return resolveNotificationTargetPath(url);
  }

  return null;
};

const RouteToastReset = () => {
  const location = useLocation();

  useEffect(() => {
    toast.dismiss();
  }, [location.pathname]);

  return null;
};

const NotificationLaunchHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;
    let listener: PluginListenerHandle | undefined;

    const handleUrl = (url?: string | null) => {
      const targetPath = resolveNotificationTargetPath(url);

      if (!targetPath) {
        return;
      }

      navigate(targetPath, {
        replace: true,
        state: NOTIFICATION_ENTRY_STATE,
      });
    };

    const register = async () => {
      const launch = await CapacitorApp.getLaunchUrl().catch(() => null);
      if (isMounted && launch?.url) {
        handleUrl(launch.url);
      }

      listener = await CapacitorApp.addListener("appUrlOpen", ({ url }) => {
        handleUrl(url);
      });
    };

    register();

    return () => {
      isMounted = false;
      listener?.remove();
    };
  }, [navigate]);

  return null;
};

// const StatusBarController = () => {
//   useEffect(() => {
//     if (Capacitor.getPlatform() !== "android") return;

//     void (async () => {
//       await StatusBar.setOverlaysWebView({
//         overlay: false,
//       });

//       await StatusBar.setBackgroundColor({
//         color: "#FFFFFFFF",
//       });

//       await StatusBar.setStyle({
//         style: Style.Dark,
//       });
//     })();
//   }, []);

//   return null;
// };

const StatusBarController = () => {
  useEffect(() => {
    if (Capacitor.getPlatform() !== "android") return;
    void (async () => {
      await StatusBar.setOverlaysWebView({ overlay: false });
      await StatusBar.setBackgroundColor({
        color: "#FFFFFFFF",
      });
      await StatusBar.setStyle({
        style: Style.Light,
      });
    })();
  }, []);

  return null;
};

const BackButtonHandler: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPathRef = React.useRef(location.pathname);
  const notificationEntryRef = React.useRef(
    Boolean(
      (location.state as { openedFromNotification?: boolean } | null)
        ?.openedFromNotification,
    ),
  );

  useEffect(() => {
    currentPathRef.current = location.pathname;
    notificationEntryRef.current = Boolean(
      (location.state as { openedFromNotification?: boolean } | null)
        ?.openedFromNotification,
    );
  }, [location.pathname]);

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      Keyboard.setResizeMode({ mode: KeyboardResize.Body });
    }
  }, []);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    let listener: PluginListenerHandle | undefined;

    const registerListener = async () => {
      listener = await CapacitorApp.addListener(
        "backButton",
        ({ canGoBack }: { canGoBack: boolean }) => {
          const isCropModalProcessing =
            document.body.dataset.cropModalProcessing === "true";

          if (isCropModalProcessing) {
            return;
          }

          const currentPath = currentPathRef.current;
          const openedFromNotification = notificationEntryRef.current;
          const shouldExitApp = [
            "/",
            "/admin",
            "/admin/login",
            "/admin/dashboard",
          ].includes(currentPath);
          const isNotificationProfileDetail =
            openedFromNotification &&
            currentPath.startsWith("/admin/profile/detail/");
          const historyCanGoBack = window.history.length > 1;

          if (shouldExitApp) {
            void CapacitorApp.exitApp();
            return;
          }

          if (isNotificationProfileDetail) {
            navigate("/admin/dashboard", { replace: true });
            return;
          }

          if (canGoBack || historyCanGoBack) {
            navigate(-1);
            return;
          }

          navigate("/admin/dashboard", { replace: true });
        },
      );
    };

    registerListener();

    return () => {
      listener?.remove();
    };
  }, [navigate]);

  return null;
};

const App = () => {
  useEffect(() => {
    initializeNotificationListeners();
  }, []);

  useEffect(() => {
    const htmlElement = document.documentElement;
    const platform = Capacitor.getPlatform();
    const platformClass = `platform-${platform}`;
    const isNative = platform === "ios" || platform === "android";

    if (isNative) {
      htmlElement.classList.add("capacitor", platformClass);
    } else {
      htmlElement.classList.remove(
        "capacitor",
        "platform-ios",
        "platform-android",
      );
    }

    return () => {
      htmlElement.classList.remove(
        "capacitor",
        "platform-ios",
        "platform-android",
        platformClass,
      );
    };
  }, []);

  const GuestRoute: React.FC<{ children: JSX.Element }> = ({ children }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [hasToken, setHasToken] = useState<boolean | null>(null);

    useEffect(() => {
      const checkSession = async () => {
        const token = await getSessionItem("sessionToken");
        setHasToken(!!token);
        setIsLoading(false);
      };
      checkSession();
    }, []);

    if (isLoading) return null; // Prevent flicker during session check

    if (hasToken) return <Navigate to="/admin/dashboard" replace />;

    return children;
  };

  return (
    <Provider store={store}>
      <BrowserRouter>
        <RouteToastReset />
        <NotificationLaunchHandler />
        <StatusBarController />
        <BackButtonHandler />
        <Routes>
          {/* Define your routes */}
          <Route path="/:id/:name" element={<MyWebSite />} />
          <Route
            path="/:id/:name/profiles/:gender"
            element={<WebsiteProfiles />}
          />
          <Route
            path="/:id/:name/:profileId"
            element={<WebsiteProfileDetail />}
          />
          <Route path="/profile">
            <Route path="register" element={<UserRegister />} />
            <Route path=":bureauId" element={<UserRegister />} />
          </Route>
          <Route
            path="/profile/:bureauId/basic/:whose"
            element={<AddProfileViaBasic />}
          />
          <Route path="/:id/:name/search" element={<Quicksearch2 />} />
          <Route
            path="/:id/:name/search/results"
            element={<QuickSearchResults />}
          />
          <Route
            path="/:id/:name/success-stories"
            element={<SuccessStoriesPage />}
          />

          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route
            path="/"
            element={
              Capacitor.isNativePlatform() ? (
                <Navigate to="/admin" replace />
              ) : (
                <NotFound />
              )
            }
          />
          <Route path="/admin">
            <Route
              path=""
              element={
                <GuestRoute>
                  <div className="login-page-lock">
                    <Login />
                  </div>
                </GuestRoute>
              }
            />
            <Route
              path="login"
              element={
                <GuestRoute>
                  <div className="login-page-lock">
                    <Login />
                  </div>
                </GuestRoute>
              }
            />
            <Route element={<ProtectedRoute />}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="wallet/transactions" element={<WalletTransactions />} />
              <Route path="settings/caste-preferences" element={<CastePreferences />} />
              <Route path="search" element={<SearchPage />} />
              <Route path="profile/edit" element={<EditMyProfile />} />
              <Route
                path="profile/detail/:profileId"
                element={<ProfileDetailPage />}
              />
              <Route path="profiles/:gender" element={<GenderProfiles />} />
              <Route
                path="profiles/:gender/:status"
                element={<GenderProfiles />}
              />
              <Route
                path="profile/manage/:profileId"
                element={<ProfileOptions />}
              />
              <Route
                path="profile/suitable/:profileId"
                element={<SuitableProfiles />}
              />
              <Route
                path="community/guidelines"
                element={<CommunityGuidelines />}
              />
              <Route path="password/change" element={<ChangePassword />} />
              <Route path="settings/privacy" element={<BureauPrivacy />} />
              <Route path="how-to-use" element={<HowToUse />} />
              <Route path="share" element={<ShareBureau />} />
              <Route path="user/profile/:whose" element={<UserRegister />} />
              <Route
                path="user/profile/basic/:whose"
                element={<AddProfileViaBasic />}
              />
              <Route path="search/mobile" element={<SearchByMobilePage />} />
              <Route path="profiles/callback" element={<CallbackProfiles />} />
              <Route
                path="profiles/not-responding"
                element={<NotRespondingProfiles />}
              />
              <Route path="website/edit" element={<EditWebsite />} />
              <Route path="website/terms" element={<TermsAndConditions />} />
              <Route
                path="website/links"
                element={<CustomizedLinksManagement />}
              />
              <Route path="website/images" element={<Sliderimages />} />
              <Route path="website/locations" element={<EditYourLocations />} />
              <Route path="website/stories" element={<SuccessStories />} />
              <Route
                path="website/testimonials"
                element={<TestimonialsManagement />}
              />
              <Route path="website/packages" element={<PackagesManagement />} />
              <Route path="website/services" element={<EditYourServices />} />
              <Route path="website/logo" element={<NavbarLogo />} />
              <Route path="website/newDetails" element={<EditNewDetails />} />
              <Route
                path="website/promotion"
                element={<EditPromotionBanners />}
              />
              <Route path="website/social" element={<EditSocialMediaLinks />} />
              <Route path="my-membership" element={<MemberShipDetail />} />
              <Route path="my-notifications" element={<MyNotifications />} />
            </Route>
            <Route
              path="advanced-search-results"
              element={<AdvancedSearchResults />}
            />
            <Route path="thankyou/:id" element={<ThankYou />} />
            <Route path="search-by-id" element={<SearchMartialID />} />
            <Route path="adminlogin" element={<AdminLogin />} />
            <Route path="edit-profile/:id" element={<EditUserProfile />} />
            {/* <Route path="user-image" element={<UserImage />} /> */}
            <Route path="membership/plans" element={<MembershipPlans />} />
            <Route path="membership/details" element={<MembershipDetails />} />
            <Route path="step_1_edit/:id" element={<Step1Edit />} />
            <Route path="step_2_edit/:id" element={<Step2Edit />} />
            <Route path="step_3_edit/:id" element={<Step3Edit />} />
            <Route path="step_4_edit/:id" element={<Step4Edit />} />
            <Route path="step_5_edit/:id" element={<Step5Edit />} />
            <Route path="step_6_edit/:id" element={<Step6Edit />} />
            <Route path="step_7_edit/:id" element={<Step7Edit />} />
            <Route path="step_8_edit/:id" element={<Step8Edit />} />
            <Route path="step_9_edit/:id" element={<Step9Edit />} />
            <Route path="step_10_edit/:id" element={<Step10Edit />} />
            <Route path="step_11_edit/:id" element={<Step11Edit />} />
            <Route path="user/profile/text" element={<AddProfileViaText />} />
            <Route path="*" element={<NotFound />} />
            {/* <Route path="profile-history/:id" element={<ProfileHistory />} /> */}
          </Route>
        </Routes>
      </BrowserRouter>
    </Provider>
  );
};

export default App;
